<template>
  <div class="category-manage">
    <el-card>
      <div slot="header" class="card-header">
        <span class="title">大类管理</span>
        <el-button type="primary" icon="el-icon-plus" @click="handleAdd">添加大类</el-button>
      </div>
      
      <el-table :data="tableData" style="width: 100%" border stripe>
        <el-table-column prop="id" label="ID" width="80"/>
        <el-table-column prop="categoryType" label="大类编码" width="150"/>
        <el-table-column prop="categoryName" label="大类名称"/>
        <el-table-column label="操作" width="200" align="center">
          <template slot-scope="scope">
            <el-button size="small" type="primary" icon="el-icon-edit" @click="handleEdit(scope.row)">编辑</el-button>
            <el-button size="small" type="danger" icon="el-icon-delete" @click="handleDelete(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      
      <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="500px">
        <el-form :model="form" :rules="rules" ref="form" label-width="100px">
          <el-form-item label="大类编码" prop="categoryType">
            <el-input v-model="form.categoryType" placeholder="如：5401"/>
          </el-form-item>
          <el-form-item label="大类名称" prop="categoryName">
            <el-input v-model="form.categoryName" placeholder="如：旅游类"/>
          </el-form-item>
        </el-form>
        <span slot="footer">
          <el-button @click="dialogVisible = false">取消</el-button>
          <el-button type="primary" @click="handleSubmit">确定</el-button>
        </span>
      </el-dialog>
    </el-card>
  </div>
</template>

<script>
import categoryApi from '../api/category'

export default {
  name: 'CategoryManage',
  data() {
    return {
      tableData: [],
      dialogVisible: false,
      dialogTitle: '添加大类',
      form: {
        categoryType: '',
        categoryName: ''
      },
      rules: {
        categoryType: [
          { required: true, message: '请输入大类编码', trigger: 'blur' }
        ],
        categoryName: [
          { required: true, message: '请输入大类名称', trigger: 'blur' }
        ]
      },
      isEdit: false
    }
  },
  mounted() {
    this.loadData()
  },
  methods: {
    async loadData() {
      try {
        const res = await categoryApi.getList()
        if (res.data.code === 200) {
          this.tableData = res.data.data
        }
      } catch (error) {
        this.$message.error('加载数据失败')
      }
    },
    handleAdd() {
      this.dialogTitle = '添加大类'
      this.isEdit = false
      this.form = {
        categoryType: '',
        categoryName: ''
      }
      this.dialogVisible = true
      this.$nextTick(() => {
        this.$refs.form.clearValidate()
      })
    },
    handleEdit(row) {
      this.dialogTitle = '编辑大类'
      this.isEdit = true
      this.form = { ...row }
      this.dialogVisible = true
    },
    handleSubmit() {
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          try {
            if (this.isEdit) {
              await categoryApi.update(this.form)
              this.$message.success('更新成功')
            } else {
              await categoryApi.add(this.form)
              this.$message.success('添加成功')
            }
            this.dialogVisible = false
            this.loadData()
          } catch (error) {
            this.$message.error('操作失败')
          }
        }
      })
    },
    handleDelete(row) {
      this.$confirm('确定删除该大类吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        try {
          await categoryApi.delete(row.id)
          this.$message.success('删除成功')
          this.loadData()
        } catch (error) {
          this.$message.error('删除失败')
        }
      })
    }
  }
}
</script>

<style scoped>
.category-manage {
  padding: 20px;
}
.card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.title {
  font-size: 18px;
  font-weight: bold;
}
</style>
